import { render, staticRenderFns } from "./DiceSlide.vue?vue&type=template&id=4a8834b1"
import script from "./DiceSlide.vue?vue&type=script&lang=js"
export * from "./DiceSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a8834b1')) {
      api.createRecord('4a8834b1', component.options)
    } else {
      api.reload('4a8834b1', component.options)
    }
    module.hot.accept("./DiceSlide.vue?vue&type=template&id=4a8834b1", function () {
      api.rerender('4a8834b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/slides/DiceSlide.vue"
export default component.exports